/*
|--------------------------------------------------------------------------
| Utilities: Parallax
|--------------------------------------------------------------------------
*/
/**
 * Parallax effect
 * http://refills.bourbon.io/components/#parallax
 * @namespace
 */
__gh__webApp.utilities.parallax = {

	/**
	 * Initialize Parallax
	 */
	"init": function(){
		this.bindEvents();
		this.loadAllParallax();
	},

	/**
	 * Load parallax elements and create the effect
	 * Bourbon's parallax component js - http://refills.bourbon.io/components/#parallax
	 */
	"loadAllParallax": function(){
		$loadParallax = $("[data-gh-parallax-window-dom]");

		$loadParallax.each(function(){
			var $parallax = $(this);

			if( $parallax.length > 0 ) {
				var plxWindowDOM 					= $parallax.data("gh-parallax-window-dom"),
					plxBackgroundDOM 				= $parallax.data("gh-parallax-background-dom"),
					$plxBackground 					= $(plxBackgroundDOM),
					$plxWindow 						= $(plxWindowDOM),

					plxWindowTopToPageTop 			= $plxWindow.offset().top,
					windowTopToPageTop 				= $(window).scrollTop(),
					plxWindowTopToWindowTop 		= plxWindowTopToPageTop - windowTopToPageTop,

					plxBackgroundTopToPageTop 		= $plxBackground.offset().top,
					windowInnerHeight 				= window.innerHeight,
					plxBackgroundTopToWindowTop 	= plxBackgroundTopToPageTop - windowTopToPageTop,
					plxBackgroundTopToWindowBottom 	= windowInnerHeight - plxBackgroundTopToWindowTop,
					plxSpeed = 0.35;

				$plxBackground.css('top', - (plxWindowTopToWindowTop * plxSpeed) + 'px');
			}

		});

	},

	/**
	 * Bind events
	 */
	"bindEvents": function(){
		var efficientLoadMoreFn = __gh__webApp.common.debounce(this.loadAllParallax, 20);
		$(document).off("scroll.gh-parallax").on("scroll.gh-parallax",this.loadAllParallax);
	}
};
